import React from "react";

export default function V2rayBtn({ setIsShowBtn, isShowBtn }) {
  const clickhandler = () => {
    setIsShowBtn((prevshow) => {
      return !prevshow;
    });
  };

  return (
    <button
      onClick={clickhandler}
      type="button"
      className={`${
        isShowBtn
          ? "box-click mt-2 btn w-100 py-3 rounded-pill shadow-lg"
          : "box mt-2 btn w-100 py-3 rounded-pill "
      }  `}
    >
      V2Ray
    </button>
  );
}
